export default __webpack_public_path__ + "static/viinitie-banner-xmass-desktop-wide.48f6f17c59f98adb58317434c7759a9c.webp";